<template>
  <div class="dark:bg-gray-900">
    <StoreProductsHeading
      :query="categoryGQL"
      :variables="{ hash, slug: $route.params.slug }"
      :update="headerUpdate"
    />
    <StoreProducts :title="name" :category="$route.params.slug" />
  </div>
</template>

<script>
import category from "@/graph/store/category.gql";
import { mapState } from "pinia";
import { useVepaarStore } from "@/store/store.js";
import { useBizStore } from "@/store/index.js";

export default {
  setup() {
    definePageMeta({
      layout: "store",
      scrollToTop: true,
    });
  },

  data() {
    return {
      name: "•••",
      categoryGQL: category,
    };
  },

  head() {
    return {
      title: this.name,
      meta: [
        {
          hid: "og:title",
          property: "og:title",
          content: this.name,
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "category",
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `${this.url}/categories/${this.$route.params.slug}`,
        },
      ],
    };
  },

  computed: {
    ...mapState(useVepaarStore, ["hash"]),
    ...mapState(useBizStore, ["url"]),
  },

  methods: {
    headerUpdate({ productCategoryBySlug: { name } }) {
      this.name = name;
      return { title: name };
    },
  },
};
</script>
